import { AlertTriangle } from 'lucide-react';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

/**
 * Estado de error estándar (hermano de EmptyState): icono, título,
 * descripción y acción de reintento opcional.
 */
export function ErrorState({
  title = 'Algo salió mal',
  description,
  onRetry,
  retryLabel = 'Reintentar',
  className,
}: ErrorStateProps) {
  return (
    <div
      role="alert"
      className={`flex flex-col items-center rounded-2xl border border-xd-error/30 bg-xd-error/5 py-16 text-center shadow-soft ${className ?? ''}`}
    >
      <span aria-hidden="true">
        <AlertTriangle className="h-10 w-10 text-xd-error/60" />
      </span>
      <p className="mt-4 text-lg font-medium text-xd-error">{title}</p>
      {description && <p className="mt-1 text-sm text-text-muted">{description}</p>}
      {onRetry && (
        <button
          onClick={onRetry}
          className="btn-action mt-6 rounded-lg px-5 py-2.5 text-sm font-semibold text-[var(--xds-fg)]"
        >
          {retryLabel}
        </button>
      )}
    </div>
  );
}
